import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=6691d13a&scoped=true&"
import script from "./AboutUs.vue?vue&type=script&lang=js&"
export * from "./AboutUs.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=6691d13a&lang=less&scoped=true&"
import style1 from "./AboutUs.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6691d13a",
  null
  
)

export default component.exports